
import { Link } from "react-router-dom";
import { FaHome, FaArrowLeft } from "react-icons/fa";

function NotFound() {

    return (

        <div className="notfound-page">

            <div className="notfound-card">

                <div className="error-number">

                    404

                </div>

                <h1>

                    Página no encontrada

                </h1>

                <p>

                    La página que intentas consultar no existe o fue movida.
                    Verifica la dirección o regresa al panel principal.

                </p>

                <div className="notfound-buttons">

                    <button
                        className="secondary-btn"
                        onClick={() => window.history.back()}
                    >

                        <FaArrowLeft />

                        Regresar

                    </button>

                    <Link to="/dashboard">

                        <button className="primary-btn">

                            <FaHome />

                            Ir al Dashboard

                        </button>

                    </Link>

                </div>

            </div>

        </div>

    );

}

export default NotFound;
